var map = {
	"./en.json": [
		"NuBg"
	],
	"./es.json": [
		"7ucu"
	],
	"./zh-CN.json": [
		"GsS1"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "gcC2";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/locales lazy ^\.\/.*\.json$
// module id = gcC2
// module chunks = 20